import { useState, useRef, type ComponentProps, useMemo } from 'react'

import { cn } from '~/utils/classnames'
import { getImageKitUrl } from '~/utils/image'

export type VideoProps = {
  src: string
  alt?: string
  displayControls?: boolean
} & Omit<ComponentProps<'video'>, 'src'>

export const Video = ({
  src,
  alt,
  displayControls,
  controls,
  className,
  ref,
  ...props
}: VideoProps & { ref?: React.Ref<HTMLVideoElement> }) => {
  const [showControls, setShowControls] = useState(false)
  const internalRef = useRef<HTMLVideoElement>(null)
  const videoRef = ref || internalRef

  const videoSrc = useMemo(() => getImageKitUrl(src), [src])

  return (
    <div className="relative h-full w-full">
      <video
        key={videoSrc}
        ref={videoRef}
        src={videoSrc}
        controls={displayControls ? showControls : controls}
        className={cn(className, 'relative h-full w-full object-cover')}
        onMouseEnter={() => setShowControls(true)}
        onMouseLeave={() => setShowControls(false)}
        autoPlay
        muted
        loop
        playsInline
        {...props}
      />
    </div>
  )
}
